<div class="sidenav-section-1" (click)="closeMenu()">
</div>
  <button mat-icon-button (click)="closeMenu()" class="menu-close-button round-button">
    <mat-icon>close</mat-icon>
  </button>
<mat-nav-list class="sidenav-section-2 w-100">
  <div class="menu-pages">
    <img src="../../assets/images/logo-solocal.svg" alt="" width="150" height="auto" class="menu_logo">

    <ng-container *ngFor="let parentPage of pageKeys">
      <mat-accordion multi>
        <mat-expansion-panel #pagesMenuPanel [expanded]="pageId === parentPage.id" [hideToggle]="true" [disabled]="parentPage.id === undefined">
          <mat-expansion-panel-header (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                      [ngClass]="{
   'page-selected': pageId === parentPage.id || isChildPageSelected(parentPage),
   'parent-undefined': parentPage.id === undefined
 }">
            <mat-panel-title #pageTitle
                             (click)="onPageClick(parentPage.id!)"
                             [attr.data-pageid]="parentPage.id"
                             [attr.data-pagetitle]="parentPage.title">
              <div class="d-flex flex-row">
                <div class="d-flex flex-row align-items-center gap-2 page-title-block">
                  <div *ngIf="parentPage.id !== undefined" class="percentage-container" [ngClass]="
                       {
                       'spinner-success' : fetchPageStats(parentPage.id!)===100,
                       'spinner-processing' : fetchPageStats(parentPage.id!)===undefined || fetchPageStats(parentPage.id!)! < 100,
                       'page-not-completed-required': userRole == RoleType.SALES && parentPage.isAllOffersNotRequired != true && fetchPageStatus(parentPage.id!) != CompletionStatus.COMPLETED
              }">
                <mat-progress-spinner
                  class="title-spinner"
                  [value]="fetchPageStats(parentPage.id!)"
                  mode="determinate"
                  strokeWidth="3"
                  diameter="37">
                </mat-progress-spinner>

                <div class="percentage-text" [ngClass]="{ 'percentage-text-spacing': fetchPageStats(parentPage.id!) === 100 }">
                  <ng-container *ngIf="fetchPageStats(parentPage.id!) === 100 && fetchPageStatus(parentPage.id!) == CompletionStatus.COMPLETED; else showPercentage">
                    <mat-icon>check</mat-icon>
                  </ng-container>
                  <ng-template #showPercentage>
                    {{ fetchPageStats(parentPage.id!) }}%
                  </ng-template>
                </div>
              </div>

                  <span class="parent-title" [ngClass]="{
                'page-readonly': parentPage.offerStatus === OfferStatus.READONLY && parentPage.id !== undefined && userRole == RoleType.ADMIN,
                'page-closed': parentPage.offerStatus === OfferStatus.CLOSED && parentPage.id !== undefined && userRole == RoleType.ADMIN,
                'page-not-required': parentPage.isAllOffersNotRequired == true && userRole != RoleType.CUSTOMER
                }"
                        tooltipTruncate
                        [matTooltip]="parentPage.title!">
                    {{ parentPage.title }}
                  </span>
                </div>
                <div class="title-panel-indicator" *ngIf="parentPage.id != undefined">

                  <mat-icon *ngIf="(userRole == RoleType.ADMIN || userRole == RoleType.DELIVERY) && !isPreview && parentPage.canExport" class="export-page-data"
                            [matTooltip]="'Export page data' | translate"
                            (click)="onExportCustomerPageData($event, parentPage)">
                    file_download
                  </mat-icon>

                  <mat-icon *ngIf="userRole == RoleType.ADMIN" class="redirect-config"
                            [matTooltip]="'Redirect to configuration' | translate"
                            (click)="onRedirectToPageConfig($event, parentPage.originId)">
                    settings
                  </mat-icon>

                  <mat-icon *ngIf="!pagesMenuPanel.expanded" class="panel-open"
                            (click)="onHeaderClick($event,pagesMenuPanel,parentPage.id!)">
                    keyboard_arrow_down
                  </mat-icon>

                  <mat-icon *ngIf="pagesMenuPanel.expanded" class="panel-close"
                            (click)="onHeaderClick($event,pagesMenuPanel,parentPage.id!)">
                    close
                  </mat-icon>
                </div>
              </div>
            </mat-panel-title>

          </mat-expansion-panel-header>

          <!-- Parent Blocks -->
          <a mat-list-item class="itemMenuBlock"
             *ngFor="let block of parentPage.blocks; let i = index" (click)="goToBlock(i)" [attr.data-blockid]="block.id" [attr.data-blockiteration]="block.iteration">
            <div class="stepContent"><div class="step"> </div></div>
            <span class="child-title" [ngClass]="{
                'page-readonly': parentPage.offerStatus === OfferStatus.READONLY && parentPage.id !== undefined && userRole == RoleType.ADMIN,
                'page-closed': parentPage.offerStatus === OfferStatus.CLOSED && parentPage.id !== undefined && userRole == RoleType.ADMIN
              }"
                  tooltipTruncate
                  [matTooltip]="block.title!">
              {{ block.title }}
            </span>
          </a>

          <!-- Summary shortcut -->
          <a mat-list-item class="itemMenuBlock" *ngIf="(userRole == RoleType.ADMIN || userRole == RoleType.SALES) && displaySummaryShortcut" (click)="goToSummary()">
            <div class="stepContent"><mat-icon>remove_red_eye</mat-icon></div>
            <span class="child-title" tooltipTruncate [matTooltip]="'Summary' | translate">
              {{ "Summary" | translate }}
            </span>
          </a>

        </mat-expansion-panel>
      </mat-accordion>
      <!-- Child Pages -->
      <mat-accordion *ngIf="pagesMap.get(parentPage)" multi>
        <mat-expansion-panel *ngFor="let childPage of pagesMap.get(parentPage)" [expanded]="pageId === childPage.id" #pagesMenuPanel [hideToggle]="true">
          <mat-expansion-panel-header [ngClass]="{'page-selected': pageId === childPage.id}" (mousedown)="$event.preventDefault(); $event.stopPropagation()">
            <mat-panel-title #pageTitle
                             (click)="onPageClick(childPage.id!)"
                             [attr.data-pagetitle]="parentPage.title">
              <div class="d-flex flex-row">
                <div class="d-flex flex-row align-items-center gap-2 page-title-block">
                  <div class="percentage-container" [ngClass]="{
                       'spinner-success' : fetchPageStats(childPage.id!)===100,
                       'spinner-processing' : fetchPageStats(childPage.id!)===undefined || fetchPageStats(childPage.id!)! < 100,
                       'page-not-completed-required': userRole == RoleType.SALES && childPage.isAllOffersNotRequired != true && fetchPageStatus(childPage.id!) != CompletionStatus.COMPLETED
                  }">
                    <mat-progress-spinner
                      class="title-spinner"
                      [value]="fetchPageStats(childPage.id!)"
                      mode="determinate"
                      strokeWidth="3"
                      diameter="37"
                      [color]="fetchPageStats(childPage.id!)! < 100 ? 'accent' : 'primary'">
                    </mat-progress-spinner>

                    <div class="percentage-text" [ngClass]="{ 'percentage-text-spacing': fetchPageStats(childPage.id!) === 100 }">
                      <ng-container *ngIf="fetchPageStats(childPage.id!) === 100 && fetchPageStatus(childPage.id!) == CompletionStatus.COMPLETED; else showPercentageChild">
                        <mat-icon>check</mat-icon>
                      </ng-container>
                      <ng-template #showPercentageChild>
                        {{ fetchPageStats(childPage.id!) }}%
                      </ng-template>
                    </div>
                  </div>

                  <span class="child-title" [ngClass]="{
                    'page-readonly': childPage.offerStatus === OfferStatus.READONLY && childPage.id !== undefined && userRole == RoleType.ADMIN,
                    'page-closed': childPage.offerStatus === OfferStatus.CLOSED && childPage.id !== undefined && userRole == RoleType.ADMIN,
                    'page-not-required': childPage.isAllOffersNotRequired == true && userRole != RoleType.CUSTOMER
                  }"
                        tooltipTruncate
                        [matTooltip]="childPage.title!">
                    #{{ childPage.title }}
                  </span>
                </div>
                <div class="title-panel-indicator">
                  <mat-icon *ngIf="(userRole == RoleType.ADMIN || userRole == RoleType.DELIVERY) && !isPreview && parentPage.canExport" class="export-page-data"
                            [matTooltip]="'Export page data' | translate"
                            (click)="onExportCustomerPageData($event, childPage)">
                    file_download
                  </mat-icon>

                  <mat-icon *ngIf="userRole == RoleType.ADMIN" class="redirect-config"
                            [matTooltip]="'Redirect to configuration' | translate"
                            (click)="onRedirectToPageConfig($event, childPage.originId)">
                    settings
                  </mat-icon>

                  <mat-icon *ngIf="!pagesMenuPanel.expanded" class="panel-open"
                            (click)="onHeaderClick($event,pagesMenuPanel,childPage.id!)">
                    keyboard_arrow_down
                  </mat-icon>

                  <mat-icon *ngIf="pagesMenuPanel.expanded" class="panel-close"
                            (click)="onHeaderClick($event,pagesMenuPanel,childPage.id!)">
                    close
                  </mat-icon>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!-- Child Blocks -->
          <a mat-list-item class="itemMenuBlock" *ngFor="let block of childPage.blocks; let i = index" (click)="goToBlock(i)" [attr.data-blockid]="block.id" [attr.data-blockiteration]="block.iteration">
            <div class="stepContent"><div class="step"> </div></div> <span class="child-title" [ngClass]="{
                'page-readonly': childPage.offerStatus === OfferStatus.READONLY && childPage.id !== undefined && userRole == RoleType.ADMIN,
                'page-closed': childPage.offerStatus === OfferStatus.CLOSED && childPage.id !== undefined && userRole == RoleType.ADMIN
              }"
                                                                           tooltipTruncate
                                                                           [matTooltip]="block.title!">{{ block.title }}</span>
          </a>

          <!-- Summary shortcut -->
          <a mat-list-item class="itemMenuBlock" *ngIf="(userRole == RoleType.ADMIN || userRole == RoleType.SALES) && displaySummaryShortcut" (click)="goToSummary()">
            <div class="stepContent"><mat-icon>remove_red_eye</mat-icon></div>
            <span class="child-title" tooltipTruncate [matTooltip]="'Summary' | translate">
              {{ "Summary" | translate }}
            </span>
          </a>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>


  </div>

  <div class="menu-footer">
    <a href="tel:3401" mat-flat-button class="cdc-button btn-white">
      <mat-icon>phone</mat-icon>
      <span class="phone-number">34 01</span>
    </a>
    <hr>
    <div class="page-footer">
      <p class="copyright mb-4">© {{currentYear}} <a href="https://www.solocal.com/" target="_blank" rel="noopener">solocal.com</a></p>
      <p class="legal-links">
        <a href="https://www.solocal.com/mentions-legales" target="_blank" rel="noopener">{{ 'Legal notices' | translate }}</a>
        <a href="https://www.solocal.com/protection-de-la-vie-privee" target="_blank" rel="noopener">{{ 'Privacy' | translate }}</a>
        <a href="https://www.solocal.com/cookies" target="_blank" rel="noopener">{{ 'Cookie information' | translate }}</a>
      </p>
    </div>
  </div>
</mat-nav-list>
